import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

const FEATURES = [
  "Multi-domain composite scoring",
  "Pattern recognition & flags",
  "Clinician-in-the-loop design",
  "Auto-suggested protocols",
  "Outcome tracking over time",
  "API integration ready",
];

export const TechnologySection = () => (
  <section id="technology" className="relative z-[1] py-28 lg:py-36 px-6 lg:px-12 overflow-hidden bg-gradient-to-b from-[#030B18] via-[#0A1628] to-[#030B18]" data-testid="technology-section">
    <div className="logo-watermark-section">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense" />
    </div>
    <div className="max-w-[1200px] mx-auto relative z-[2]">
      <motion.div
        className="bg-[rgba(3,11,24,0.92)] p-8 rounded-xl mb-12 max-w-[600px]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-4 text-shadow">
          The Engine
        </div>
        <h2 className="font-orbitron text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[3px] leading-tight mb-5 text-white text-shadow">
          Integrated Matrix Engine
        </h2>
        <p className="font-outfit text-xl font-light leading-relaxed text-white/90">
          Decision support layer that surfaces patterns and risk signals — clinicians retain final authority.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <motion.div
          className="feature-img aspect-[4/5] rounded-lg overflow-hidden"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <img src={ASSETS.doctorData} alt="Integrated Matrix Engine" className="w-full h-full object-cover" />
        </motion.div>

        <motion.div
          className="bg-[rgba(3,11,24,0.92)] p-8 rounded-xl"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <h3 className="font-orbitron text-2xl lg:text-3xl font-bold tracking-[2px] mb-5 text-white text-shadow">
            Intelligent Decision Support
          </h3>
          <p className="font-outfit text-xl leading-relaxed text-white/90 font-light mb-5">
            Maps intake, labs, and history into multi-domain views — surfacing patterns for faster, personalized plans.
          </p>
          <ul className="list-none flex flex-col gap-3 mt-4">
            {FEATURES.map((feat, i) => (
              <li key={i} className="font-outfit text-lg text-white/80 pl-6 relative font-light">
                <span className="absolute left-0 text-[#60A5FA] text-xl">▸</span>
                {feat}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
